import React, { useState, useRef } from 'react'
import { FormattedDate, FormattedTime, useIntl } from 'react-intl'
import { selectUnit } from '@formatjs/intl-utils'
import Icon from 'components/Icon'

const Audition = ({ timestamp, body, title, last, orderId, meta }) => {
  const linkRef = useRef()
  const [copied, setCopied] = useState(false)
  const { link } = meta

  const onCopy = (event) => {
    linkRef.current.select()
    linkRef.current.focus()

    try {
      document.execCommand('copy')
      setCopied(true)
    } catch(error) {
      console.error(error)
    }
  }

  return (
    <li>
      <div className="relative pb-8">
        { !last &&
          <span className="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
        }
        <div className="relative flex items-start space-x-3">
          <div>
            <div className="relative px-2 mt-2">
              <div className="h-6 w-6 bg-positive rounded-full ring-4 ring-white flex justify-center items-center">
                <Icon icon="microphone" className="text-xs text-white" />
              </div>
            </div>
          </div>

          <div className="min-w-0 flex-1 py-0">
            <div className="text-sm leading-6">
              <div className="border border-gray-200 rounded-sm mb-2">
                <div className="p-2 flex justify-between items-center">
                  <span>{ title }</span>

                  <a target="_blank" href={link} className="ml-2 text-primary cursor-pointer hover:text-primary-darker">
                    Open <Icon icon="external-link" />
                  </a>
                </div>
                <p className="p-2 border-t border-gray-200">
                  We have preparred a landing page with your auditions where you can listen to your auditions. You can share this link with clients and colleagues. 
                </p>
                <div className="p-2 border-t border-gray-200 flex justify-between items-center space-x-2" onClick={onCopy}>
                  <input ref={linkRef} readOnly value={link} className="truncate w-full grow font-mono text-gray-700 text-xs" />
                  <Icon icon={copied ? 'check' : 'copy'} className="text-primary cursor-pointer" />
                </div>
              </div>

              <span className="whitespace-nowrap text-gray-500 text-xs">
                <FormattedDate value={timestamp * 1000} /> <FormattedTime value={timestamp * 1000} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </li>
  )
}

export default Audition
